export interface UserEditFields {
  UserName: string;
  DisplayName: string;
  GivenName: string;
  FamilyName: string;
  JobTitle: string;
  CompanyName: string;
  Department: string;
  EmployeeId: string;
  StreetAddress: string;
  State: string;
  Country: string;
  Office: string;
  City: string;
  ZipCode: string;
  OfficePhone: string;
  MobilePhone: string;
}

const USER_EDIT_FIELD_KEYS: (keyof UserEditFields)[] = [
  'UserName', 'DisplayName', 'GivenName', 'FamilyName', 'JobTitle', 'CompanyName', 'Department', 'EmployeeId',
  'StreetAddress', 'State', 'Country', 'Office', 'City', 'ZipCode', 'OfficePhone', 'MobilePhone'
];

const EMPTY_PLACEHOLDER = '-- --';

// The user record carries the read view's "-- --" placeholder for empty values; it must not reach the inputs.
const normalizeEditValue = (value: string | null | undefined): string =>
  value === EMPTY_PLACEHOLDER ? '' : (value || '');

export const toUserEditFields = (user?: Partial<Record<keyof UserEditFields, string | null>>): UserEditFields =>
  USER_EDIT_FIELD_KEYS.reduce((fields, key) => {
    fields[key] = normalizeEditValue(user?.[key]);
    return fields;
  }, {} as UserEditFields);

export const isUserEditChanged = (current: UserEditFields, initial: UserEditFields): boolean =>
  USER_EDIT_FIELD_KEYS.some(key => current[key] !== initial[key]);
